import React from "react";
import { useForm } from "react-hook-form";

const useFormCreateExpense = ({ default_title_note, mutate_add_note }) => {
    const methods = useForm({
        mode: "onSubmit",
        defaultValues: {
            title: default_title_note,
            rebillable: false,
            client: null,
        },
    });

    const onSubmit = (data) => {
        mutate_add_note(data);
        return;
    };

    return {
        methods,
        onSubmit,
    };
};

export default useFormCreateExpense;
